import { injectable } from 'inversify';
import container from '@core/di';
import BaseStore from '@core/stores/base';
import { makeObservable, observable, action } from 'mobx';
import NotificationService from '@shared/services/notification';
import { Alert, ALERT_TYPE } from '@shared/models/alert';

@injectable()
export default class NotificationStore extends BaseStore<Alert, NotificationService> {
  static diToken = Symbol('notification-store');
  private _alert: Alert | null | undefined = undefined;

  constructor() {
    super({ service: container.get<NotificationService>(NotificationService.diToken) });
    makeObservable<any>(this, {
      _alert: observable,
      clearAlert: action,
      alertMessage: action,
    });
  }

  get alert(): Alert | null | undefined {
    return this._alert;
  }

  clearAlert = () => {
    this._alert = null;
  };

  alertMessage = (message: string | unknown, type = ALERT_TYPE.WARNING) => {
    this._alert = new Alert({
      type,
      message: typeof message === 'string' ? message : String(message),
    });
  };
}
